import {Injectable} from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import {Observable} from 'rxjs';
import {tap} from 'rxjs/operators';
import {ApplicationStateService} from '../services';
import {MessageService} from 'primeng/api';
import {
  EnvanaDownRedMessage,
  EnvanaDownYellowMessageForCp1
} from '../../../apps/vida/src/modules/shared/constant/envana';

@Injectable()
export class EnvanaDownInterceptor implements HttpInterceptor {

  private static redMessageUrls = ['/pumpSchedule/carbonfooprint-per-barrel/'];

  private static redMessageUrlPattern =  /\/carbonFootPrint\/compute\/[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}\/false\/false/i;

  private static yellowMessageUrlPatterns = [
    /\/carbonFootPrint\/compute\/[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}\/true\/true/i,
    /\/carbonFootPrint\/[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}\/\d+\/CalculateScope3Emissions\/true/i
  ];

  constructor(private appStateService: ApplicationStateService, private messageService: MessageService) {}

  private getMessageType(url: string): 'red' | 'yellow' | null {
    if (EnvanaDownInterceptor.yellowMessageUrlPatterns.some(pattern => pattern.test(url))) {
      return 'yellow';
    }

    if (EnvanaDownInterceptor.redMessageUrlPattern.test(url)) {
      return 'red';
    }

    // Check for red message URLs
    if (EnvanaDownInterceptor.redMessageUrls.some(redUrl => url.includes(redUrl))) {
      return 'red';
    }

    return null;
  }


  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const messageType = this.getMessageType(request.url);

    if (messageType) {
      request = request.clone();

      return next.handle(request).pipe(
        tap(
          () => {
            this.appStateService.isEnvanaDown$.next(false);
          },
          (error: HttpErrorResponse) => {
            if (messageType === 'red') {
              if (error.status === 503 || error.status === 500) {
                this.messageService.add(new EnvanaDownRedMessage());
                this.appStateService.isEnvanaDown$.next(true);
              }
            } else {
              if (error.status === 503 || error.status === 500) {
                this.messageService.add(new EnvanaDownYellowMessageForCp1());
                this.appStateService.isEnvanaDown$.next(true);
              }
            }

          }
        )
      );
    }

    return next.handle(request);
  }
}
